var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-6",staticStyle:{"position":"absolute","top":"0"},style:(_vm.style_margin_position)},[_c('div',{staticClass:"myCanvas",attrs:{"id":_vm._uid}},[_c('md-icon',{staticClass:"md-primary interaction-widget"},[_vm._v("zoom_in")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }